/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNoMedication = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path
          clipRule="evenodd"
          d="m14 6 2 2.667v1.405a6.95 6.95 0 0 0-2 .602V9.333L13 8H5L4 9.333V20h6.675a6.99 6.99 0 0 0 1.428 2H2V8.667L4 6V2h10zM6 6h6V4H6z"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M13.465 13.465a5 5 0 1 1 7.07 7.07 5 5 0 0 1-7.07-7.07zm2.241 6.243a3.002 3.002 0 0 0 4.002-4.002zm2.588-5.416a3.002 3.002 0 0 0-4.002 4.002z"
          fillRule="evenodd"
        />
        <path d="M10 13h1.257a6.97 6.97 0 0 0-.966 2H10v2H8v-2H6v-2h2v-2h2z" />
      </g>
    </g>
  </Icon>
);
export { SvgNoMedication as NoMedication };
